import { SimpleResult } from "../dto";
import {
  CopyToSupplierExistingBehavior,
  PriceRateAdjustmentType,
  PriceRoundingBehavior,
} from "../enums";
import { Api, getCompanyId } from "../helpers";
import { IRydeProcess } from "../models";

interface IUpdateBasePriceArguments {
  ids: number[];
  percentageOfIncrease: number;
  roundFinalPrice: boolean;
  currencyAdditionKeysToIncrease?: string[];
}

interface ICopyToSupplierPriceRatesArguments {
  ids: number[];
  adjustmentType: PriceRateAdjustmentType;
  adjustmentValue: number;
  supplierIds: number[];
  existingBehavior?: CopyToSupplierExistingBehavior;
  roundingBehavior?: PriceRoundingBehavior;
  decimalDigits?: number;
}

export class PriceRateApi {
  static async updateBasePrice({
    ids,
    percentageOfIncrease,
    roundFinalPrice,
    currencyAdditionKeysToIncrease,
  }: IUpdateBasePriceArguments): Promise<
    SimpleResult<IRydeProcess> | undefined
  > {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/priceRates/bulk/update_base_price`;

    const response = await Api.patch<SimpleResult<IRydeProcess>>(requestUrl, {
      ids,
      roundFinalPrice,
      percentageOfIncrease,
      ...(currencyAdditionKeysToIncrease?.length
        ? { currencyAdditionKeysToIncrease }
        : {}),
    });

    return response?.data;
  }

  static async copyToSupplierPriceRates({
    ids,
    adjustmentType,
    adjustmentValue,
    supplierIds,
    existingBehavior,
    roundingBehavior,
    decimalDigits,
  }: ICopyToSupplierPriceRatesArguments): Promise<
    SimpleResult<IRydeProcess> | undefined
  > {
    const requestUrl = `/api/v1/core/c/${getCompanyId()}/priceRates/bulk/copy_to_supplier_price_rates`;

    const response = await Api.patch<SimpleResult<IRydeProcess>>(requestUrl, {
      ids,
      adjustmentType,
      adjustmentValue,
      supplierIds,
      existingBehavior,
      roundingBehavior,
      decimalDigits,
    });

    return response?.data;
  }
}
